import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'
import { Box, Flex } from '@chakra-ui/react'
import { Container, Content, PageTitle } from 'src/components/Layout'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import { SidebarCard } from 'src/components/SidebarCard/SidebarCard'
import styles from './ClaimType.module.less'

import intlMessages from './translations'

class ClaimType extends Component {
  state = {
    types: [
      {
        hideArrow: true,
        icon: ['far', 'pen-field'],
        title: this.props.intl.formatMessage(intlMessages.claimsClaimTypeForm),
        description: this.props.intl.formatMessage(intlMessages.claimsClaimTypeFormSubtitle),
        isColumn: true,
        onClick: e => {
          this.goTo(e, '/claims/form')
        },
      },
      {
        hideArrow: true,
        action: 'call',
        icon: ['fal', 'phone-arrow-up-right'],
        title: this.props.intl.formatMessage(intlMessages.claimsClaimTypeCall),
        description: this.props.intl.formatMessage(intlMessages.claimsClaimTypeCallSubtitle),
        isColumn: true,
        onClick: e => {
          this.goTo(e, '/claims/phones')
        },
      },
    ],
  }

  renderIcon = icon => {
    return (
      <Box opacity={0.5}>
        <FontAwesomeIconComponent icon={icon} size='sm' type='card-font' />
      </Box>
    )
  }

  goTo = (e, url) => {
    e.preventDefault()
    if (url === '/claims/form') {
      this.props.setDisclaimer(true)
    }
    this.props.history.push(url)
  }

  handleBack = () => {
    this.props.history.push('/')
  }

  render() {
    const { intl, features, claimSettings } = this.props

    const foundedFeature = features.find(f => f.id == 'reportClaim')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.claimsHeader)
    const showClaimNumbers =
      claimSettings.hasOwnProperty('showClaimNumbers') && claimSettings.showClaimNumbers === true

    const typesClassnames = cx({
      [styles.cards]: true,
      [styles.cardsWithoutCall]: !showClaimNumbers,
    })

    return (
      <Flex>
        <Content>
          <PageTitle title={title} showBackMobile={true} />
          <Container className={styles.container}>
            <div className={typesClassnames}>
              {this.state.types.map(type => {
                if (!showClaimNumbers && type.action === 'call') {
                  return
                }
                return (
                  <SidebarCard
                    item={type}
                    title={type.title}
                    isColumn={true}
                    noMargin={true}
                    icon={this.renderIcon(type.icon)}
                    key={type.title}
                    onClick={type.onClick}
                    active={true}
                    size={'lg'}
                  >
                    {type.description}
                  </SidebarCard>
                )
              })}
            </div>
          </Container>
        </Content>
      </Flex>
    )
  }
}

export default withRouter(injectIntl(ClaimType))
